import React, { CSSProperties } from "react"
import { Form, Select, type SelectProps } from "antd"
import type { Rule } from "antd/lib/form"
import "./index.css"

interface StyledSelectProps extends SelectProps {
  name: string
  rules?: Rule[]
  inputAlign?: string
  options?: { value: any; label: string }[]
  prefixText?: string
  stylesPrefix?: CSSProperties
  showPrefix?: boolean
  required?: boolean
  mode?: "multiple" | "tags" | undefined
  allowClear?: boolean
  defaultValue?: any
  disabled?: boolean
  value?: any
  onChange?: ((value: any, option: any) => void) | undefined
  onSelect?: ((value: any, option: any) => void) | undefined
}

const SelectPrefixForm: React.FC<StyledSelectProps> = ({
  name,
  rules,
  options,
  inputAlign,
  prefixText,
  stylesPrefix,
  showPrefix = true,
  required = false,
  ...props
}) => {
  const displayText = prefixText || name
  const finalText = required ? `${displayText}*` : displayText

  return (
    <div className="custom-select-wrapper">
      {showPrefix && (
        <div style={stylesPrefix} className="custom-select-label">
          <span className="custom-select-label-text">{finalText}</span>
        </div>
      )}
      <Form.Item rootClassName="custom-select-form-item" name={name} rules={rules} style={{ margin: 0 }}>
        <Select
          options={options}
          className={`${showPrefix ? (inputAlign ?? "custom-select-with-label") : "custom-select-no-label"}`}
          rootClassName="custom-select-form-item"
          style={{
            textAlign: "center",
          }}
          {...props}
        />
      </Form.Item>
    </div>
  )
}

export default SelectPrefixForm
